// ./components/PropertyCard.jsx
import React from "react";
import CircleIcon from "mdi-react/CircleOutlineIcon";
import CheckCircleIcon from "mdi-react/CheckCircleOutlineIcon";
import StarIcon from "mdi-react/StarCircleOutlineIcon";

function PropertyCard(props) {
  var property = props.property;
  var index = props.property.id;
  var isSubject = props.isSubject;
  var isSelected = props.isSelected;
  var onSelect = props.onClick; // selection click handler
  var showSelectIcon = props.showSelectIcon;
  var compSource = props.compSource;
  var buttonText = props.buttonText;
  var openDetailModal = props && props.openDetailModal ? props.openDetailModal : null; // optional
  var showChangeButton = props.showChangeButton;
  var avgDOMVal = props.avgDOM;
  var disableSelect = props.disableSelect;
  var linkURL = props.linkURL;

  // pass from parent to render edited HTML (falls back to raw nodes)
  var renderOrFallback =
	typeof props.renderEditedOrDefault === "function"
	  ? props.renderEditedOrDefault
	  : function (id, fallback) { return fallback; };

  var cardKey = compSource + "-" + index;
  var dragStartX = 0;
  var dragThreshold = 5;

  function handleMouseDown(e) {
	dragStartX = e.clientX;
  }

  function suppressedByDrag(e) {
	return Math.abs(e.clientX - dragStartX) > dragThreshold;
  }

  function handleCardClick(e) {
	if (suppressedByDrag(e)) {
	  e.preventDefault();
	  e.stopPropagation();
	  return;
	}
	if (openDetailModal) {
	  openDetailModal(property.id);
	}
  }

  function handleBadgeClick(e) {
	// prevent bubbling to card click
	e.stopPropagation();
	if (suppressedByDrag(e)) {
	  e.preventDefault();
	  return;
	}
	// if disabled and not already selected, ignore
	if (disableSelect && !isSelected) {
	  e.preventDefault();
	  return;
	}
	if (typeof onSelect === "function") {
	  onSelect(e);
	}
  }

  function handleBadgeKeyDown(e) {
	if (e.key === "Enter" || e.key === " ") {
	  e.preventDefault();
	  handleBadgeClick(e);
	}
  }

  function handleLinkClick(e) {
	// avoid triggering card click when clicking "See Details"
	e.stopPropagation();
  }

  return (
	<div
	  className={
		"property-card item-" +
		index +
		" " +
		(isSubject ? "subject" : "comp") +
		" " +
		(!isSelected && showSelectIcon ? "not-selected" : "")
	  }
	  onClick={openDetailModal ? handleCardClick : null}
	  onMouseDown={handleMouseDown}
	  style={{ cursor: openDetailModal ? "pointer" : "default" }}
	>
	  <div className="relative">
		<div className={"banner " + (isSubject ? "subject" : "comp")}>
		  {isSubject ? <StarIcon /> : null}
		  {!isSubject && !isSelected && showSelectIcon ? "ALT COMP" : property.tag}
		  {!isSubject ? <span className="small-text">({property.currentStatus})</span> : null}
		</div>

		<img src={property.img} alt={property.title} className="property-image" id={cardKey + "-photo"} />
		<div className="trigger-upload-image print-hide" data-image-key={cardKey + "-photo"}><span>Change Photo</span></div>

		{!isSubject && showSelectIcon ? (
		  <div
			className={
			  "property-badge " +
			  (isSubject ? "badge-subject" : "badge-comp select-comp") +
			  " " +
			  (isSelected ? "selected" : "not-selected") +
			  (disableSelect && !isSelected ? " disabled" : "")
			}
			onClick={handleBadgeClick}
			onKeyDown={handleBadgeKeyDown}
			role="button"
			tabIndex={disableSelect && !isSelected ? -1 : 0}
			aria-pressed={!!isSelected}
			aria-disabled={!!(disableSelect && !isSelected)}
			data-comp-key={property.id}
		  >
			{showSelectIcon ? (
			  <div className="select-check">
				{isSelected ? (
				  <CheckCircleIcon style={{ width: 30, height: 30 }} />
				) : (
				  <CircleIcon style={{ width: 30, height: 30 }} />
				)}
			  </div>
			) : null}
			{isSubject ? property.tag : buttonText}
		  </div>
		) : null}

		{showChangeButton && !isSubject ? (
		  <div
			data-comp-key={property.id}
			className="property-badge comp-chg print-hide badge-comp open-comps"
		  >
			<span className="comp-tag">Change Comp</span>
		  </div>
		) : null}
	  </div>

	  <div className="property-details">
		<div className={"property-title-wrapper property-title-wrapper-" + index}>
		  {renderOrFallback(
			cardKey + "-title",
			<h3 id={cardKey + "-title"} className="property-title editable track-original">
			  {property.title}
			</h3>
		  )}

		  {renderOrFallback(
			cardKey + "-location",
			<p id={cardKey + "-location"} className="property-location editable track-original">
			  {property.location}
			</p>
		  )}

		  {linkURL ? (
			<div key={property.id} data-key={property.id} className="property-detail">
			  <a
				href={linkURL}
				className="comp-link"
				target="_blank"
				rel="noreferrer"
				onClick={handleLinkClick}
			  >
				See Details
			  </a>
			</div>
		  ) : property.id && property.id[0] == "p" ? (
			<div
			  key={property.id}
			  data-key={property.id}
			  className="property-detail open-detail print-hide"
			>
			  <span className="comp-link">See Details</span>
			</div>
		  ) : null}
		</div>

		<div className={"property-info-box property-info-box-" + index}>
		  {renderOrFallback(
			cardKey + "-type",
			<p id={cardKey + "-type"} className="property-info-title editable track-original">
			  {property.type}
			</p>
		  )}
		  {renderOrFallback(
			cardKey + "-year-distance",
			<p id={cardKey + "-year-distance"} className="property-info-subtext editable track-original">
			  Year Built: {property.yearBuilt}
			  {!isSubject ? <span><br />Distance: {property.distance}</span> : <span><br />Distance: --</span>}
			</p>
		  )}
		</div>

		<div className={"property-info-box property-info-box-" + index}>
		  {renderOrFallback(
			cardKey + "-bedsBaths",
			<p id={cardKey + "-bedsBaths"} className="property-info-title editable track-original">
			  {property.bedsBaths}
			</p>
		  )}
		  {renderOrFallback(
			cardKey + "-size",
			<p id={cardKey + "-size"} className="property-info-subtext editable track-original">
			  {property.size}
			</p>
		  )}
		</div>

		<div className={"property-info-box property-info-box-" + index}>
		  {renderOrFallback(
			cardKey + "-price",
			<p id={cardKey + "-price"} className="property-info-title editable track-original">
			  {property.price}
			</p>
		  )}
		  {renderOrFallback(
			cardKey + "-price-meta",
			<p id={cardKey + "-price-meta"} className="property-info-subtext editable track-original">
			  {property.priceType} {property.date ? "(" + property.date + ")" : ""}
			</p>
		  )}
		</div>

		<div className={"property-info-box property-info-box-" + index}>
		  {renderOrFallback(
			cardKey + "-psf",
			<p id={cardKey + "-psf"} className="property-info-title editable track-original">
			  {property.psf || "N/A"}
			</p>
		  )}
		  {renderOrFallback(
			cardKey + "-psf-meta",
			<p id={cardKey + "-psf-meta"} className="property-info-subtext editable track-original">
			  {property.psfType} {property.date ? "(" + property.date + ")" : ""}
			</p>
		  )}
		</div>

		{/* Rental cards omit daysOnMarketHeading to drop the DOM stat; sale data always sets it. */}
		{compSource === "activeComps" && property.daysOnMarketHeading ? (
		  <div className={"property-info-box property-info-box-" + index}>
			{renderOrFallback(
			  cardKey + "-dom",
			  <p id={cardKey + "-dom"} className="property-info-title editable track-original">
				{isSubject ? avgDOMVal : property.daysOnMarket}
			  </p>
			)}
			{renderOrFallback(
			  cardKey + "-dom-heading",
			  <p id={cardKey + "-dom-heading"} className="property-info-subtext editable track-original">
				{property.daysOnMarketHeading}
			  </p>
			)}
		  </div>
		) : null}
	  </div>
	</div>
  );
}

export default PropertyCard;
